import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavItem } from '@core/services/menu/menu.service';

@Component({
  selector: 'Teranet-MenuItem',
  templateUrl: './menu-item.component.html'
})
export class MenuItemComponent implements OnInit {
  @Input() items: NavItem[];
  @ViewChild('childMenu', { static: true }) public childMenu: any;

  constructor(public router: Router) {
  }

  ngOnInit() {
  }
}
